<template>
<div class="item-edit">
	<b-form @submit.prevent="submitAndStay"
	        class="mb-3">
		<div class="row">

			<div class="col">
				<h1 class="display-4"
				    v-if="mode == 'edit'">{{ $t('item.edit') }}</h1>
				<h1 class="display-4"
				    v-if="mode == 'add'">{{ $t('item.addPageTitle') }}</h1>
				<h2>{{ form.title }}</h2>
			</div>

			<div class="col">
				<action-buttons class="pull-right"
				                @previous-item="previousItem"
				                @next-item="nextItem"
				                :disable-previous="item.previous_id == null"
				                :disable-next="item.next_id == null"
				                @save-and-back="submitAndBack"
				                @save-and-new="submitAndNew"
				                @back="goBack"
				                :disable-delete="true">
				</action-buttons>
			</div>

		</div>

		<b-alert v-if="formError.errors"
		         show
		         variant="warning">
			<span v-for="errors in formError.errors">
					<span v-for="error in errors">{{ error }}<br /></span>
			</span>
		</b-alert>

		<partial-loader :loading="isFetching"></partial-loader>

		<div v-if="!isFetching && !isLoading">
			<div class="row">
				<div class="col">
					<div class="row">
						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-9">
							<seller-field @update:person="updateSellerId"
							              :mode="mode">
							</seller-field>
						</div>

						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-3">
							<b-form-group :label="`${$t('item.itemNumber')} *`">
								<b-input-group>
									<b-input-group-prepend is-text v-if="seller.code">{{ seller.code }}</b-input-group-prepend>
									<b-form-input type="number"
									              v-bind:disabled="seller.code == null"
									              step="1"
												  autocomplete="off"
									              v-model="form.number">
									</b-form-input>
								</b-input-group>
							</b-form-group>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-9">
							<category-field ref="categoryField"
											:mode="mode"
							                @update:category="updateCategoryId">
							</category-field>
						</div>
						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-3">
							<b-form-group :label="$t('item.auctionOrderNumber')">
								<b-form-input type="number"
								              step="1"
										  	  autocomplete="off"
								              v-model="form.auction_order_number">
								</b-form-input>
							</b-form-group>
						</div>
					</div>

					<b-form-group :label="`${$t('item.title')} *`">
						<b-form-input type="text"
						              id="title"
									  autocomplete="off"
						              v-model="form.title">
						</b-form-input>
					</b-form-group>

					<b-form-group :label="$t('item.tags')">
						<multiselect 
							v-model="form.tags" 
							tag-placeholder="Add this as new tag" 
							placeholder="Search or add a tag" 
							label="name" 
							track-by="name" 
							:options="tags"
							:loading="isFetchingTags" 
    						:close-on-select="false"
							:multiple="true" 
							:taggable="true" 
						/>
					</b-form-group>

					<div class="row">

						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
							<b-form-group :label="$t('item.parts')">
								<b-form-input type="number"
								              step="any"
								              min="0"
											  autocomplete="off"
								              v-model="form.parts"></b-form-input>
							</b-form-group>
						</div>

						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
							<b-form-group :label="$t('item.quality')">
								<multiselect v-model="form.quality"
								             id="quality"
								             :select-label="$t('common.select')"
								             :placeholder="$t('item.selectQuality')"
								             :selectedLabel="$t('common.selected')"
								             :deselectLabel="$t('common.deselect')"
								             :options="qualityOptions"></multiselect>
							</b-form-group>
						</div>

						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
							<b-form-group :label="$t('item.limit')">
								<b-input-group>
									<b-input-group-prepend is-text>
										<i class="fas fa-euro-sign fa-fw"></i>
									</b-input-group-prepend>
									
									<b-form-input type="number"
									              class="text-right"
									              step="1"
												  autocomplete="off"
									              v-model="form.limit"></b-form-input>
								</b-input-group>
							</b-form-group>
						</div>

					</div>

					<div class="row">

						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-8">
							<div class="row">
								<div class="col-xs-12 col-sm-6">
									<b-form-group :label="$t('item.targetprice', { number: 1 })">
										<b-input-group>
											<b-input-group-prepend is-text>
												<i class="fas fa-euro-sign fa-fw"></i>
											</b-input-group-prepend>

											<b-input type="number"
											         class="text-right"
											         step="1"
											         v-model="form.target_price_1"></b-input>
										</b-input-group>
									</b-form-group>
								</div>

								<div class="col-xs-12 col-sm-6">
									<b-form-group :label="$t('item.targetprice', { number: 2 })">
										<b-input-group>
											<b-input-group-prepend is-text>
												<i class="fas fa-euro-sign fa-fw"></i>
											</b-input-group-prepend>

											<b-form-input type="number"
											              class="text-right"
											              step="1"
														  autocomplete="off"
											              v-model="form.target_price_2"></b-form-input>
										</b-input-group>
									</b-form-group>
								</div>
							</div>

							<div class="row">
								<div class="col-xs-12 col-sm-6">
									<b-form-group :label="$t('item.sellerCommisionPercentage')">
										<b-input-group>
											<b-input-group-prepend is-text>
												<i class="fas fa-percentage fa-fw"></i>
											</b-input-group-prepend>

											<b-form-input type="number"
											              step="any"
														  autocomplete="off"
											              v-model="form.seller_commission_percentage"></b-form-input>
										</b-input-group>
										<b-form-text v-if="form.seller_commission_percentage > 0 && form.seller_commission > 0">
											{{ $t('item.sellerCommissionPercentageIgnored') }}
										</b-form-text>
									</b-form-group>
								</div>

								<div class="col-xs-12 col-sm-6">
									<b-form-group :label="$t('item.sellerCommission')">
										<b-input-group>
											<b-input-group-prepend is-text>
												<i class="fas fa-euro-sign fa-fw"></i>
											</b-input-group-prepend>

											<b-form-input type="number"
											              class="text-right"
											              step="any"
														  autocomplete="off"
											              v-model="form.seller_commission">
											</b-form-input>
										</b-input-group>
									</b-form-group>
								</div>
							</div>
						</div>

						<div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
							<b-form-group>
								<b-form-checkbox v-model="form.no_photo_cost"
								                 value="1"
								                 unchecked-value="0">
									{{ $t('item.noPhotoCost') }}
								</b-form-checkbox>
							</b-form-group>

							<b-form-group label=""
							              v-show="mode == 'edit'">
								<b-form-checkbox v-model="form.paid"
								                 value="1"
								                 unchecked-value="0">
									{{ $t('item.paid') }}
								</b-form-checkbox>
							</b-form-group>
						</div>

					</div>

				</div>

				<div class="col-sm-12 col-xl-6">
					<b-form-group :label="$t('item.description')">
						<b-form-textarea v-model="form.description"
						                 :rows="14">
						</b-form-textarea>
					</b-form-group>

					<p v-if="!isFetching && mode != 'add' && item['moved_from_item_id'] !== null" class="font-italic">
						{{ $t('item.movedFrom') }} <router-link :to="{ name: 'itemEdit', params: { auctionId: item['moved_from']['auction_id'], itemId: item['moved_from']['item_id'] }}"> deze veiling. </router-link>
					</p>

					<autocomplete-auction v-if="!isFetching && item.bid == null && pendingBids.meta.total < 1 && item['moved_to_item_id'] == null"
					                      :selected="item.auction"
					                      :label="$t('item.auctionMove')"
					                      @update:auction="changeAuctionModal"
					                      :deletable="false"
					                      :reset-after="true"
					                      :hide-selected="true"
					                      :searchable="false"
					                      :placeholderLabel="$t('item.selectAuction')"
					                      :allow-empty="false"></autocomplete-auction>

					<p v-else-if="!isFetching && mode != 'add' && item['moved_to_item_id'] !== null" class="font-italic">
						{{ $t('item.movedTo') }} <router-link :to="{ name: 'itemEdit', params: { auctionId: item['moved_to']['auction_id'], itemId: item['moved_to']['item_id'] }}"> deze veiling. </router-link>
					</p>

					<p v-else
					   class="font-italic">{{ $t('item.cantMove') }}
					</p>

					<modal ref="changeAuctionModal"
					       :title="$t('item.auctionMove')">

						<div slot="modal-body">
							<div class="row">
								<div class="col">
									{{ $t('item.auctionMoveDialog', { auctionName: modals.auction.title }) }}
								</div>
							</div>
						</div>
						<div slot="modal-footer">
							<div class="row">
								<div class="col">
									<b-button class="mt-3"
									          type="button"
									          variant="outline-primary"
									          block
									          @click="cancelAuctionModal">{{ $t('common.cancel') }}</b-button>
								</div>
								<div class="col">
									<b-button class="mt-3"
									          type="button"
									          v-bind:disabled="modals.auction.loading"
									          block
									          variant="outline-danger"
									          @click="updateAuctionId(modals.auction.selected)">

										<loader-spinner :text="$t('item.auctionMove')"
										                :show-spinner="modals.auction.loading"></loader-spinner>

									</b-button>
								</div>
							</div>
						</div>
					</modal>
				</div>
			</div>

			<b-form-group label="Afbeeldingen:">
				<media v-if="mode == 'edit'"></media>
				<b-alert variant="warning"
				         v-if="mode == 'add'"
				         show>Sla het kavel op om afbeeldingen toe te voegen.
					<b-button type="submit"
					          size="sm"
					          variant="primary"><i class="fa fa-fw fa-save"></i> Sla direct op</b-button>
				</b-alert>
			</b-form-group>

			<small>{{ $t('common.requiredFields') }}</small>

			<action-buttons class="pull-right"
			                @previous-item="previousItem"
			                @next-item="nextItem"
			                :disablePrevious="item.previous_id == null"
			                :disableNext="item.next_id == null"
			                @save-and-back="submitAndBack"
			                @save-and-new="submitAndNew"
			                @back="goBack"
			                :disable-delete="true">
			</action-buttons>
		</div>

	</b-form>

</div>
</template>

<script>
import { isNil, pick, forEach, remove, forOwn } from 'lodash';
import { createNamespacedHelpers } from 'vuex';
import { flashSuccess, flashDanger, flashWarning } from '@/helpers/flash-message-helper';
import Multiselect from 'vue-multiselect';
import Media from './ItemMedia';
import PersonService from '@/services/person-service';
import ItemService from '@/services/item-service';
import AutocompleteAuction from '@/components/elements/AutocompleteAuction';
import ActionButtons from '@/components/elements/Edit/ActionButtons';
import PartialLoader from '@/components/elements/PartialLoader';
import SellerField from './SellerField';
import CategoryField from './CategoryField';
import { setTitle } from '@/helpers/page-helper';
import { mergeBreadcrumb } from '@/helpers/breadcrumb-helper';
import Modal from '@/components/elements/Base/BaseDialogModal';
import LoaderSpinner from '@/components/elements/LoaderSpinner';
import { mapGetters as mapGlobalGetters, mapActions as mapGlobalActions } from 'vuex';

const { mapGetters, mapActions } = createNamespacedHelpers('item');

export default {
	components: {
		Multiselect,
		Media,
		AutocompleteAuction,
		ActionButtons,
		PartialLoader,
		SellerField,
		CategoryField,
		Modal,
		LoaderSpinner
	},
	data() {
		return {
			form: {},
			mode: 'add',
			seller: {},
			isLoading: false,
			selectedAuction: false,
			changeAuctionName: '',
			qualityOptions: ['A', 'B', 'C', 'D'],
			modals: {
				auction: {
					loading: false,
					selected: null,
					title: null
				}
			},
		}
	},
	computed: {
		...mapGetters([
			'item',
			'lastCreatedItem',
			'pendingBids',
			'isFetching',
			'formError',
		]),
		...mapGlobalGetters([
			'tags',
			'isFetchingTags',
		]),
		itemNumber() {
			if (this.mode != 'edit') {
				return this.$t('item.addPageTitle');
			} else if (isNil(this.item.seller)) {
				return '';
			}

			return `${this.item.seller.code}-${this.item.number}`;
		},
	},
	watch: {
		form() {
			forOwn(this.form, (formValue, formKey) => {
				if (isNil(formValue)) formValue = null;
			});
		},
		'$route': 'reloadForm',
		//'lastCreatedItem': 'setLastCreatedFields'
	},
	methods: {
		...mapActions([
			'resetAll',
			'resetLastCreatedItem',
			'fetchItem',
			'fetchPendingBids',
			'insertItem',
			'updateItem',
			'fetchAutocompleteSeller',
			'updateItemSeller',
			'moveItem',
		]),
		...mapGlobalActions([
			'fetchTags',
		]),
		setEditFields() {
			this.form = pick(this.item, [
				'title',
				'description',
				'number',
				'auction_order_number',
				'target_price_1',
				'target_price_2',
				'limit',
				'seller_commission',
				'seller_commission_percentage',
				'historical_price',
				'seller_id',
				'category_id',
				'paid',
				'no_photo_cost',
				'quality',
				'parts',
				'tags',
			]);

			if (this.form.target_price_1)
				this.form.target_price_1 = Math.round(this.form.target_price_1);
			if (this.form.target_price_2)
				this.form.target_price_2 = Math.round(this.form.target_price_2);
			if (this.form.limit)
				this.form.limit = Math.round(this.form.limit);
			if (this.item.seller)
				this.seller = this.item.seller;

			mergeBreadcrumb([{}, {}, { meta: { title: this.itemNumber } }]);
		},

		/**
		 * Clear the form
		 */
		clearForm() {
			this.resetAll();
			this.seller = {};
			this.form = {};
			this.mode = 'add';			

			this.setLastCreatedFields();
		},

		/**
		 * Reload the form
		 */
		async reloadForm() {
			this.clearForm();

			if (!isNil(this.$route.params.itemId)) {
				this.mode = 'edit';
				await this.fetchStoreItem(this.$route.params.itemId);
			}
		},

		setLastCreatedFields() {

			if (!isNil(this.lastCreatedItem.category)) {
				this.$set(this.form, 'category_id', this.lastCreatedItem.category.id);
			}

			if (!isNil(this.lastCreatedItem.seller)) {
				this.$set(this.form, 'seller_id', this.lastCreatedItem.seller.id);
				this.seller = this.lastCreatedItem.seller;
			}
		},

		/**
		 * Update Seller Id
		 * @param  {object} seller
		 */
		async updateSellerId(seller) {
			if (!isNil(seller)) {
				this.form.seller_id = seller.id;
				this.seller = seller;

				if (isNil(seller.code)) {
					flashWarning(this.$t('seller.noSellerCode'));
					this.form.number = null;
				} 
				else {
					const response = await ItemService.getNextAuctionItemNumber(this.$route.params.auctionId, seller.id);
					this.$set(this.form, 'number', response);
				}
			}
		},

		/**
		 * Update category Id
		 * @param  {object} category Category with id
		 */
		updateCategoryId(category) {
			if (!isNil(category)) {
				this.form.category_id = category.id;
			} else {
				this.$set(this.form, 'category_id', null);
			}
		},

		changeAuctionModal(auction) {
			if (!isNil(auction)) {
				this.modals.auction.selected = auction;
				this.modals.auction.title = auction.title;
				this.$refs.changeAuctionModal.show();
				return false;
			}
		},

		/**
		 * Update auction Id
		 * @param  {object} auction Auction with id
		 */
		async updateAuctionId(auction) {
			if (!isNil(auction)) {
				this.form.auction_id = auction.id;

				const response = await this.moveItem({
					itemId: this.$route.params.itemId,
					body: this.form,
				});

				!this.formError && flashSuccess(this.$t('item.moveSuccess'), true);

				this.cancelAuctionModal();
				this.$router.push({ name: 'itemEdit', params: { auctionId: response['auction_id'], itemId: response.id } });
			}
		},

		cancelAuctionModal() {
			this.form.auction_id = this.item.auction_id;
			this.$refs.changeAuctionModal.hide();
		},

		/**
		 * Fullname with code
		 * @param  {string}  full_name
		 * @param  {integer} code
		 * @return {string}				full_name with code combined
		 */
		fullNameWithCode({ full_name, code }) {
			if (isNil(code)) return `${full_name}`;
			return `${full_name} (${code})`;
		},

		/**
		 * If string is empty return null
		 * @param  {string} string
		 * @return {null}
		 */
		emptyToNull(string) {
			if (isNil(string)) string = null;

			return string;
		},

		/**
		 * Submit the form
		 * @return {Promise}
		 */
		async submitForm(nextPage = false) {
			const post = {}

			forOwn(this.form, (formValue, formKey) => {
				formValue = isNil(formValue) ? null : formValue;

				if (formValue !== this.item[formKey]) {
					post[formKey] = isNil(formValue) ? null : formValue;
				}
			});

			try {
				post.auction_id = this.$route.params.auctionId;

				if (this.mode == 'add') {
					const response = await this.insertItem({ body: post });

					if (!this.formError) {
						await this.reloadForm();

						flashSuccess(this.$t('item.createSuccess'), nextPage);

						return response;
					}
				}

				else {
					const response = await this.updateItem({
						itemId: this.$route.params.itemId,
						body: post
					})

					if (!this.formError) {
						await this.reloadForm();

						flashSuccess(this.$t('item.updateSuccess'), nextPage);

						return response;
					}
				}
			}
			catch (error) {}
		},

		/**
		 * Submit form and go to edit page
		 * @param  {Event} e event from the form submission
		 */
		async submitAndStay(e) {

			try {
				const response = await this.submitForm(true);

				!this.formError && this.$router.push({ name: 'itemEdit', params: { itemId: response.id } });	
			}
			catch (error) {
				console.log(error);	
			}			
		},

		/**
		 * Submit and back
		 */
		async submitAndBack() {
			await this.submitForm(true)

			!this.formError && this.goBack();
		},

		/**
		 * Submit and new
		 */
		async submitAndNew() {
			this.isLoading = true;
			
			await this.submitForm(this.mode == 'edit');

			if (this.formError == false) {
				if (this.mode == 'edit') {
					this.clearForm();
					this.$router.push({ name: 'itemAdd' });
				}
				else
					this.clearForm();
			}

			this.isLoading = false;
		},

		/**
		 * Previous Item
		 */
		previousItem() {
			this.$refs.categoryField.resetSelection();
			this.$router.push({ name: 'itemEdit', params: { itemId: this.item.previous_id } });
		},

		/**
		 * Next Item
		 */
		nextItem() {
			this.$refs.categoryField.resetSelection();
			this.$router.push({ name: 'itemEdit', params: { itemId: this.item.next_id } });
		},

		/**
		 * Go Back
		 */
		goBack() {
			this.$router.push({ name: 'itemList' });
		},

		async fetchStoreItem() {
			try {
				await this.fetchItem(this.$route.params.itemId);
				this.setEditFields();
			}
			catch (error) {
				console.log(error);
			}
		}
	},

	beforeMount() {
		this.resetLastCreatedItem();
		this.reloadForm();
		this.fetchTags();
	},
	
	async mounted() {
		// check if item id exists otherwise add
		if (!isNil(this.$route.params.itemId)) {
			this.mode = 'edit';
			
			try {
				await this.fetchStoreItem(this.$route.params.itemId);
				setTitle(this.$t('item.editPageTitle', { itemNumber: this.itemNumber }))
			}
			catch (error) {
				console.log(error);
			}
		}

	}
}
</script>



// WEBPACK FOOTER //
// ItemForm.vue?6445ddce